module.exports = __webpack_public_path__ + "static/media/PullmandelSur-Website-HomeV2-Bloque-29.d1862a56.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/pullmansur/parcel/PullmandelSur-Website-HomeV2-Bloque-29.png
// module id = 1846
// module chunks = 0